export const makeBoxVars = (prefix, value) => {
	if (!value) return {};
	const vars = {};

	const sides = ["top", "right", "bottom", "left"];
	sides.forEach((side) => {
		if (value[side]) vars[`--sfb-${prefix}-${side}`] = value[side];
	});

	return vars;
};

export const getAllSpacingVars = (attributes) => {
	const {
		paddingDesktop,
		paddingTablet,
		paddingMobile,
		marginDesktop,
		marginTablet,
		marginMobile,
	} = attributes;

	const all = {
		...makeBoxVars("padding-desktop", paddingDesktop),
		...makeBoxVars("padding-tablet", paddingTablet),
		...makeBoxVars("padding-mobile", paddingMobile),
		...makeBoxVars("margin-desktop", marginDesktop),
		...makeBoxVars("margin-tablet", marginTablet),
		...makeBoxVars("margin-mobile", marginMobile),
	};

	// ✅ Remove empty/undefined styles entirely
	return Object.fromEntries(Object.entries(all).filter(([_, v]) => v));
};
